export const ZERO_HASH = '0x0000000000000000000000000000000000000000000000000000000000000000';
export const BYTES_10 = '0x000000000000000000000000000000000000000000000000000000000000000a';
export const FIVE_PERCENTAGE = '50000000000000000000000000';
export const TWO_PERCENTAGE = '20000000000000000000000000';
export const FIFTY_PERCENTAGE = '500000000000000000000000000';
export const THIRTY_PERCENTAGE = '300000000000000000000000000';
export const REPRESENTATIVES_PANEL_NAME = 'Representatives';
